<template>
    <div class="page">
        <div class="main mt-4">
            <div class="container">
                <div class="bonus-points-record-block">
                    <div class="invalid">
                        <span class="mr-3">未生效 {{$public.numberFormat(rewardPointInfo.notActivePoint)}} 點</span>
                        <span class="mr-3">已使用 {{$public.numberFormat(rewardPointInfo.usedPoint)}} 點</span>
                        <span>已失效 {{$public.numberFormat(rewardPointInfo.invalidPoint)}} 點</span>
                    </div>
                    <div class="record-table">
                        <div class="title">
                            <div @click="changeSort($event,'createdAt',0)" class="filter active"  ref="createdAtBtn">日期</div>
                            <div class="min-w-90">內容</div>
                            <div @click="changeSort($event,'point',1)" class="filter">點數</div>
                            <div @click="changeSort($event,'pointsStartDate',2)" class="filter">生效日</div>
                            <div @click="changeSort($event,'pointsDeadlineDate',3)" class="filter">到期日</div>
                        </div>
                        <div class="detail">
                            <div class="day">
                                <div class="list" v-for="(item, index) in dataList" :key="index">
                                    <div class="time" v-html="dateFormat(item.createdAt)">
                                    </div>
                                    <div class="min-w-90" @click="onClickContent(item)">
                                        {{item.name}}<span class="red" v-if="item.tableType === 3 && item.status === 1">(退回)</span>
                                        <img src="@/assets/images/message.svg" class="ps-icon" v-if="item.relationType === 2">
                                    </div>
                                    <div>{{$public.numberFormat(item.point)}}</div>
                                    <div class="time" :class="(item.tableType === 1 && item.status === 5 ? 'red' : '')" v-html="dateFormat(item.pointsStartDate)">
                                    </div>
                                    <div class="time" v-html="dateFormat(item.pointsDeadlineDate, true)">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <infinite-loading spinner="waveDots" v-if="isSetUp" @infinite="setupDataScroll">
                      <div slot="no-more">沒有更多資料</div>
                      <div slot="no-results"></div>
                    </infinite-loading>
                </div>
            </div>
        </div>

        <el-dialog
                v-if="showRemarkDialog"
                :visible.sync="showRemarkDialog"
                :show-close="false"
                append-to-body
                custom-class="bonusPointsDialog">
            <div class="container">
                <h4 class="outer-content">{{remarkInfo.title}}</h4>
                <div class="main-content">
                    <div class="d-flex mt-2">
                        <el-image v-if="remarkInfo.img !== ''" :src="remarkInfo.img" fit="cover"/>
                        <div class="mt-3">
                            <b>{{remarkInfo.name}} {{remarkInfo.phone}}</b>
                            <div v-html="remarkInfo.content"/>
                        </div>
                    </div>
                    <el-divider class="mb-3 mt-3"/>
                    <div v-if="remarkInfo.note !== ''" class="mb-2">備註：<span class="d-inline-block">{{remarkInfo.note}}</span></div>
                    <div v-if="remarkInfo.message !== ''">留言：<span class="d-inline-block">{{remarkInfo.message}}</span></div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click="showRemarkDialog = false">確定</el-button>
                </div>
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {notNull} from "@/util/common";

    const scanQRCodeUse = 1;
    const openScan = 2;

    export default {
        name: "BonusPointsRecord",
        props: {
          rewardPointInfo: {
            default() {
              return {}
            }
          },
          isReloadRecord: Boolean,
        },
        data() {
            return {
                dataList: [],
                isSetUp: false,
                delayRun: null,

                /****備註彈窗****/
                showRemarkDialog: false,
                remarkInfo: {},

                infiniteLoadingState: '',
                offset: 0,
                pageSize: 10,
                sortField: '',
                sortType: '',
                sortClickCount: '',
            }
        },
        mounted() {
            let self = this;
            this.delayRun = setTimeout(() => {
                self.isSetUp = true;
                // console.log(`mounted BonusPointsRecord ! ${JSON.stringify(rewardPointInfo)}`);
            }, 100) ;
        },
        beforeDestroy() {
            //清除延遲執行
            clearTimeout(this.delayRun);
        },
        methods: {
            setupDataScroll($state) {
              let self = this;
              self.infiniteLoadingState = $state;
              self.isLoading = true;

              self.$http.fetchWithAuthEncrypt`GetMyselfRewardPointRecord${{
                id: self.rewardPointInfo.id,
                offset: self.offset,
                pageSize: self.pageSize,
                sortField: self.sortField === '' ? "createdAt" : self.sortField,
                sortType: self.sortType === ''? "desc" : self.sortType,
              }} ${json => {
                self.isLoading = false;

                if (notNull(json.data)) {
                  if (json.data.length >= self.pageSize) {
                    self.offset++;
                    self.dataList.push(...json.data);
                    $state.loaded();
                  } else {
                    self.offset++;
                    self.dataList.push(...json.data);
                    $state.complete();
                  }
                } else {
                  $state.complete();
                }
              }}`;
            },
            changeSort(event, sortField, type) {
              let sortObj = this.$public.setSortFilter(event, this.sortField, sortField, this.sortType, this.sortClickCount, type)

              this.sortField = sortObj.sortField
              this.sortType = sortObj.sortType
              this.sortClickCount = sortObj.sortClickCount

              this.offset = 0;
              this.dataList = [];

              if (this.infiniteLoadingState !== '') {
                this.infiniteLoadingState.reset();
              }
            },
            dateFormat(date, isCheckInfinite = false) {
              let str = date !== "" ?`<span>${date.slice(0, 4)}</span><span>${date.slice(5, 7)}/${date.slice(8, 10)}</span><span>${date.slice(11, 16)}</span>` : "";

              if(isCheckInfinite) {
                str = date.slice(0, 4) === "0001" ? "無期限" : str
              }

              return str
            },
            onClickContent(item) {
              let self = this;
              if(item.relationType === 2) {
                self.isLoading = true;
                self.$http.fetchWithAuthEncrypt`GetRewardPointRecordInfo${{
                  id: item.id,
                  tableType: item.tableType,
                  relationType: item.relationType,
                  relationTypeId: item.relationTypeId,
                  giftType: item.giftType,
                }} ${json => {
                  if(json.status) {
                    if(notNull(json.data)) {
                      let data = json.data;
                      let remarkInfo = self.remarkInfo;
                      if(item.giftType === 13 || item.giftType === 5) {
                        let typeName = (item.giftType === 13 ? "轉出" : "轉入");
                        remarkInfo.title = `點數${typeName}`;
                        remarkInfo.img = data.picture;
                        remarkInfo.name = data.name;
                        remarkInfo.phone = data.phone;
                        remarkInfo.content = `${typeName}${self.rewardPointInfo.name} <b class="red">${self.$public.numberFormat(item.point)}</b> 點`;
                        remarkInfo.note = data.note;
                        remarkInfo.message = data.message;
                      }

                      self.showRemarkDialog = true;
                    }
                  } else {
                    self.$public.showNotify(json.message, false);
                  }

                  self.isLoading = false;
                }}`;
              }
            },
        },
        watch: {
            'rewardPointInfo.id': function() {
                this.isSetUp = true;
                console.log(`rewardPointInfo BonusPointsRecord ! ${this.isSetUp}`);
            },
            isReloadRecord() {
                if(this.isReloadRecord) {
                    this.sortField =  '';
                    this.sortType =  '';
                    this.sortClickCount = '';
                    this.$refs.createdAtBtn.click();
                }
            },
        },
    }
</script>
<style lang="less" scoped>
    .bonus-points-record-block{
        .invalid{
            margin: 0 auto 5px;
            padding-right: 12px;
            font-size: 12px;
            text-align: right;
            img{
                width: 22px;
            }
            @media(min-width: 768px){
                font-size: 14px;
            }
        }
        .record-table{
            width: 100%;
            margin: 0 auto;
            box-shadow: var(--box-shadow);
            border-radius: 20px;
            padding: 5px;
            .title{
                display: flex;
                flex-wrap: nowrap;
                div{
                    padding: 5px;
                    font-size: 14px;
                    flex: 1;
                    justify-content: center;
                    text-align: center;
                    position: relative;
                    &:not(:last-child)::before{
                        content: "";
                        width: 1px;
                        height: 13px;
                        background: var(--color-dark);
                        right: -5px;
                        top: 11px;
                        position: absolute;
                    }
                    @media(min-width: 768px){
                        font-size: 16px;
                    }
                }
                /*篩選*/
                .filter {
                    //正序
                    &.active{
                        font-weight: 500;
                        &::after{
                            color: var(--color-dark2);
                        }
                    }
                    //反序
                    &.active-Re{
                        font-weight: 500;
                        &::after{
                            color: var(--color-dark2);
                            transform: rotate(0deg);
                        }
                    }
                    &::after{
                        content: "▴\fe0e";
                        position: absolute;
                        color: #ccc;
                        font-size: 12px;
                        font-weight: normal !important;
                        transform: rotate(180deg);
                        right: 0;
                        @media(min-width: 768px){
                            font-size: 16px;
                            right: 5px;
                        }
                    }
                }
            }
            .detail{
                font-size: 12px;
                @media(min-width: 768px){
                    font-size: 14px;
                }
                .year{
                    background: var(--color-yellow);
                    color: #fff;
                    width: 20%;
                    padding: 0 0 0 15px;
                    margin: 0 0 0 -5px;
                    border-radius: 0 30px 30px 0;
                }
                .day{
                    margin-bottom: 20px;
                }
                .list{
                    display: flex;
                    flex-wrap: nowrap;
                    &:nth-child(even){
                        background: #ececec;
                        border-radius: 8px;
                    }
                    div{
                        padding: 5px;
                        text-align: center;
                        flex: 1;
                        justify-content: center;
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        line-height: 1.25em;
                        @media(min-width: 768px){
                            min-height: 50px;
                        }
                        //時間用欄位
                        &.time{
                            @media(max-width: 767px){
                                transform: scale(.9);
                                flex-direction: column;
                            }
                            @media(min-width: 768px){
                                flex-wrap: nowrap;
                                /deep/span{
                                    margin: 0 2px;
                                }
                            }
                        }
                    }
                    //點數轉出icon
                    .ps-icon{
                        width: 22px;
                        margin: 5px 2px;
                    }
                }
            }
        }
    }
    //彈框
    .bonusPointsDialog{
        .main-content{
            text-align: left !important;
        }
        .el-image {
            border-radius: 20px;
            flex: 0 0 80px;
            margin-right: 10px;
            height: 80px;
            /deep/img {
                width: 80px !important;
                height: 80px;
            }
        }
    }
</style>